import sample_1 from './100_39339.jpg';
import sample_2 from './100_44755.jpg';

export const outdoorImpressions = {
    sample_1,
    sample_2,
};
